import { Component, h } from 'preact';
import { HopplerModal } from '../../common/hoppler-modal-component';
import { InquiryGridSearchInput } from './inquiry-grid-search-input';
import { InquiryListResponse } from 'types/inquiries';
import { ReqState } from '../../../../../types/request-state.model';
import { InquiryGridCard } from '../grid/inquiry-grid-card.component';

interface InquiryGridSearchModalProps {
  onSearch?: (search?: string) => void;
  searchInput?: string;
  resultCount?: number;
  results?: InquiryListResponse;
  lastViewedStage: string;

  searchReqState?: ReqState;
}
interface InquiryGridSearchModalState {
  searchInput?: string;
}

export class InquiryGridSearchModal extends HopplerModal<InquiryGridSearchModalProps, InquiryGridSearchModalState> {
  doModalClose() {
  }

  componentDidMount() {
    this.setState({ searchInput: this.props.searchInput || '' });
  }

  onSearchInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.setState({ searchInput: target.value });
  }

  onSearchClick() {
    if (this.props.onSearch) {
      this.props.onSearch(this.state.searchInput);
    }
  }

  getResultsSection(props: InquiryGridSearchModalProps, state: InquiryGridSearchModalState) {
    if (props.results && props.searchReqState !== ReqState.IN_PROGRESS) {
      return props.results.results.map(
        result => <InquiryGridCard inquiry={ result }
          alwaysRender={ true }
          stageSlug='search' />
      );
    } else if (props.searchReqState === ReqState.IN_PROGRESS) {
      return (
        <div className="hi-inqsearch-modal__spinner">
          <i className="fa fa-cog fa-spin fa-2x" />
        </div>
      );
    }
  }

  render(props: InquiryGridSearchModalProps, state: InquiryGridSearchModalState) {
    return this.modalize(
      <div className="hi-inqsearch-modal">
        <div className="hi-inqsearch-modal__header">
          <span className="hi-inqsearch-modal__heading">
            Search
          </span>

          <a href={ `/kumita-brokers/inquiries/${props.lastViewedStage}` } className='hi-inqsearch-modal__close-button'>
            <i className="fas fa-times" /> Close
          </a>
        </div>

        <div className="hi-inqsearch-modal__body">
          <div className="hi-inqsearch-modal__controls">
            <div className="form-group">
              <label className="hi-input-label mb-1">Search</label>
              <InquiryGridSearchInput
                resultCount={ props.resultCount }
                onInput={ evt => this.onSearchInput(evt) }
                searchInput={ this.state.searchInput } />
            </div>
            <button className="btn btn-secondary w-100"
              onClick={ () => this.onSearchClick() }
              disabled={ props.searchReqState === ReqState.IN_PROGRESS }>
              Search
            </button>
          </div>

          <div className="hi-inqsearch-modal__results">
            { this.getResultsSection(props, state) }
          </div>
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps: InquiryGridSearchModalProps) {
    this.setState({ searchInput: nextProps.searchInput });
  }
}
